import type { Snippet } from "svelte";

export type ActionState = {
  active?: boolean;
  checked?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  hover?: boolean;
  placeholderShown?: boolean;
  indeterminate?: boolean;

  /**
 *
 *
 */
  isInteractive?: boolean;
};

export type ActionProps = {
  Host: HTMLElement;
  display?: string;
  name?: string;
  children?: Snippet;
  actionState?: ActionState;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const getActionFlag = (
  p: string,
  style: CSSStyleDeclaration,
  inputElement?: HTMLInputElement | undefined,
  getProp?: (el: HTMLInputElement, prop: string) => boolean,
): boolean => (inputElement ? getProp!(inputElement, p) : style.getPropertyValue(p) !== "0");

/**
 *
 */
export const useUpdateActionState = (
  getActionState: () => ActionState,
  getActionElement: () => HTMLElement | undefined,
  getInputElement: () => HTMLInputElement | undefined,
): (() => void) => {
  return () => {
    const actionState = getActionState();
    const actionElement = getActionElement();
    const inputElement = getInputElement();
    if (!actionElement) return;

    /*                                                     */
    const style = getComputedStyle(actionElement);

    const updatedState: ActionState = {
      active: getActionFlag("--active", style),
      checked: getActionFlag("--checked", style, inputElement, (e) => e.checked),
      disabled: getActionFlag("--disabled", style, inputElement, (e) => e.disabled),
      hover: getActionFlag("--hover", style),
      invalid: getActionFlag("--invalid", style),
      placeholderShown: getActionFlag("--placeholder-shown", style),
      indeterminate: getActionFlag("--indeterminate", style, inputElement, (e) => e.indeterminate),
    };

    Object.assign(actionState, updatedState);
  };
};
